import React from 'react';
import './style.scss';
import { useSelector } from 'react-redux';

const ThreeDotsLoader = () => {
  const asset = useSelector(state => state.asset);
  const loaderGift =
    asset?.iptelmex_configuration_loading ||
    'https://clarovideocdn0.clarovideo.net//pregeneracion//cms//apa//a9028c58f218a7afd2d32ad11d0058e0//finplayer_nextEpisode_loading.gif?1624299637';

  return (
    <div className="Newsearch-ThreeDotsLoader">
      <img
        className="Newsearch-ThreeDotsLoader__imgLoader"
        src={loaderGift}
        alt="loader-three-dots"
      />
    </div>
  );
};

export default ThreeDotsLoader;
